export const smartphone = () => (
  <path
    d="M12 18h.01M7 2h10a2 2 0 012 2v16a2 2 0 01-2 2H7a2 2 0 01-2-2V4a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
